export const GeneralStockTypeDropDown = [
    {name : 'Anticipated',value:'anticipated'},{name : 'Dummy',value:'dummy'},{name:'Sale Order',value:'SaleOrder'},{name : 'Super Dummy',value:'superDummy'},{name:'General Item',value:'GeneralItem'}
]
export enum generalStockTypeEnum {
    Anticipated = 'anticipated',
    Dummy = 'dummy',
    SaleOrder = 'SaleOrder',
    SuperDummy = 'Super Dummy',
    GeneralItem='General Item'
}